<template>
  <div class="app-view-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppViewContainer'
}
</script>

<style scoped>
.app-view-container {
  max-width: 3000px !important;
  padding: 0 50px;
}

@media (max-width: 1024px) {
  .app-view-container {
    padding: 0 10px;
  }
}
</style>
